import React from 'react';
import { Card, CardBody, Button } from '@heroui/react';
import { motion } from 'framer-motion';
import api from '../services/api';
import { useHistory, useLocation } from 'react-router-dom';

const ConfirmEmailPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = React.useState<'idle'|'loading'|'success'|'error'>('idle');
  const [message, setMessage] = React.useState<string>('');

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uid = params.get('uid');
    const token = params.get('token');

    if (!uid || !token) {
      setStatus('error');
      setMessage('Неверная ссылка подтверждения. Пожалуйста, проверьте письмо и попробуйте снова.');
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        setStatus('loading');
        setMessage('Отправка запроса подтверждения...');
        const resp = await api.post('/users/confirm-email/', { uid, token });
        if (cancelled) return;
        // assume backend returns 200 on success
        setStatus('success');
        setMessage('Спасибо — ваша почта успешно подтверждена. Теперь вы можете войти в систему.');
      } catch (err: any) {
        console.error('Confirm email error', err);
        setStatus('error');
        // try to extract message from server
        const serverMsg = err?.response?.data?.detail || err?.response?.data?.message || 'Не удалось подтвердить почту. Попробуйте ещё раз.';
        setMessage(String(serverMsg));
      }
    })();

    return () => { cancelled = true; };
  }, [location.search]);

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-md mx-auto"
        >
          <Card className="border border-divider">
            <CardBody className="p-8 text-center">
              {status === 'loading' && (
                <>
                  <h2 className="text-2xl font-medium mb-4">Подтверждение почты</h2>
                  <p className="text-foreground/70">{message}</p>
                </>
              )}

              {status === 'success' && (
                <>
                  <h2 className="text-2xl font-medium mb-4">Почта подтверждена</h2>
                  <p className="text-foreground/70 mb-6">{message}</p>
                  <Button color="primary" variant="flat" onPress={() => history.push('/auth')}>Перейти к входу</Button>
                </>
              )}

              {status === 'error' && (
                <>
                  <h2 className="text-2xl font-medium mb-4">Ошибка подтверждения</h2>
                  <p className="text-foreground/70 mb-6">{message}</p>
                  <div className="flex gap-3 justify-center">
                    <Button color="default" variant="flat" onPress={() => history.push('/auth')}>На страницу входа</Button>
                    <Button color="primary" variant="flat" onPress={() => window.location.reload()}>Повторить попытку</Button>
                  </div>
                </>
              )}

            </CardBody>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default ConfirmEmailPage;
